import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useAcademy() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)
  
  const refetch = () => {
    setLoading(true)

    api.get("/academy/")
    .then((res: SuccessFetch<{
      payload: {
        academy_id: number
        academy_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.academy_name, value: item.academy_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/academy/").then((res: SuccessFetch<{
      payload: {
        academy_id: number
        academy_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.academy_name,
          value: item.academy_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}